import dayjs from 'dayjs';

export const isReadOnly = (assignment) => {
  return assignment.submissionCount !== 0 && assignment.status != 'DRAFT';
};

export const isTaskNotSetUp = (questions) => {
  if (!questions || questions.length === 0) {
    return true;
  }
  const hasQuestionWithContent = questions.some((question) => {
    const hasQuestionText = question.question && question.question.trim().length > 0;
    const hasPopupData = question.taskType || (question.feedbackTypes && question.feedbackTypes.length > 0);
    return hasQuestionText || hasPopupData;
  });
  
  return !hasQuestionWithContent;
};

export const isFeedbackMethodNotSelected = (reviewedBy) => {
  return reviewedBy === 'NONE';
};

export const noClassSelected = (classIds) => {
  return !classIds || classIds.length === 0;
};

export const isDueDateNotSet = (dueAt) => {
  if (!dueAt) return true;

  return false;
};

export const isDueDateOneHourAfterPublish = (publishScheduledAt, dueAt) => {
  if (!publishScheduledAt || !dueAt) return false;

  const publishDate = dayjs(publishScheduledAt);
  const dueDate = dayjs(dueAt);
  return dueDate.diff(publishDate, 'minute') >= 60;
};

// areFirstThreeStepsCompleted lived here. Its only job was disabling the
// Publish button, which made incomplete tasks fail silently — a click did
// nothing and said nothing. It was also a second, weaker copy of the rules in
// CreateNewTask/utils/validators.jsx. Completeness is now checked in one place,
// by validateAssignment, which explains what is missing.

export const shouldShowSaveAsDraftButton = (assignment) => {
  return assignment.status === 'DRAFT';
};

export const shouldShowPublishNowButton = (assignment) => {
  return (
    assignment.status === 'DRAFT' ||
    assignment.status === 'SCHEDULED' ||
    assignment.status === 'PUBLISHED'
  );
};

export const shouldShowDeleteButton = (assignmentId, assignment) => {
  return assignment.status == 'SCHEDULED';
};

export const shouldShowSubjectSection = (selectedClassesWithSubjects) => {
  if (!selectedClassesWithSubjects?.length) return false;
  if (selectedClassesWithSubjects.length > 1) return true;
  return (selectedClassesWithSubjects[0]?.subjects?.length ?? 0) > 1;
};

export const canDeselectSubject = (selectedClassesWithSubjects, selectedSubjects, subjectTitle, selectedSubjectByClassId, classId) => {
  if (classId != null && selectedSubjectByClassId != null) {
    const arr = selectedSubjectByClassId[classId];
    if (!Array.isArray(arr) || arr.length === 0) return false;
    const after = arr.filter((s) => s !== subjectTitle);
    return after.length >= 1;
  }
  const afterDeselect = selectedSubjects.filter((s) => s !== subjectTitle);
  const multiSubjectClasses = selectedClassesWithSubjects.filter(({ subjects }) => subjects.length > 1);
  return multiSubjectClasses.every(({ subjects }) => {
    const classSubjectTitles = subjects.map((s) => (typeof s === 'object' ? s.title : s));
    const stillSelected = afterDeselect.filter((s) => classSubjectTitles.includes(s));
    return stillSelected.length >= 1;
  });
};
